import { APIModel } from 'app/state/api';
import { ApiCallModel } from 'app/state/api/interfaces';

const paymentMethod: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_PAYMENTS_API}/get-payment-method`),
};

export default paymentMethod;
